import { UseCase } from '../UseCase';
import { StatusResponse } from '../../models/StatusResponse';
import { SessionRepository } from '../../repositories/SessionRepository';
export class ChangePasswordUseCase implements UseCase<ChangePasswordRequestDto, StatusResponse>{

    constructor(
        private sessionRepo: SessionRepository
    ) { }

    execute(t: ChangePasswordRequestDto): Promise<StatusResponse> {
        return this.sessionRepo.updatePassword(t.oldPassword, t.newPassword);
    }
}

export class ChangePasswordRequestDto {
    constructor(
        public oldPassword: string,
        public newPassword: string
    ) { }
}